// extracted by mini-css-extract-plugin
module.exports = {"Emoji":"bbr_a bhs_i bhs_q bhs_j"};